import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getGstinTypeSlice = createAsyncThunk(
  "gstinType/getGstinType",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/gstinType/getGstinType", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getGstinTypeById = createAsyncThunk(
  "gstinType/getGstinTypeById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/gstinType/getGstinTypeById", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const initialState = {
  gstinTypes: [],
  gstinTypeInfo: null,
  loading: false,
  searchGstinTypeErrorMessage: null,
};

const gstinTypeSlice = createSlice({
  name: "gstinType",
  initialState,
  reducers: {
    resetSearchGstinTypeMessage: (state) => {
      state.searchGstinTypeErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGstinTypeSlice.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getGstinTypeSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.searchGstinTypeErrorMessage = action?.payload?.result?.message;
        }
        state.gstinTypes = action.payload.result.list;
      })
      .addCase(getGstinTypeSlice.rejected, (state, action) => {
        state.loading = false;
        state.searchGstinTypeErrorMessage = action?.payload?.result?.message;
      });
  },
});

export const { resetSearchGstinTypeMessage } = gstinTypeSlice.actions;
export default gstinTypeSlice.reducer;
